<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
          Donor uri
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-input
        type="textarea"
        class="textarea-stripe-container"
        autosize
        v-model="donor_uris">
        </el-input>
      </el-row>
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
          Uri
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-input
        type="textarea"
        class="textarea-stripe-container"
        autosize
        v-model="uris">
        </el-input>
      </el-row>
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
          Referer
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-input
        type="textarea"
        class="textarea-stripe-container"
        autosize
        v-model="referers">
        </el-input>
      </el-row>
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Mode
        </el-col>
        <el-col :span="16">
          <el-select v-model="model.params.mode"  placeholder="Select mode">
            <el-option
            v-for="item in modes"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Min time
        </el-col>
        <el-col :span="16">
            <el-input-number size="mini" v-model="model.params.min_time"></el-input-number>        
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Max time
        </el-col>
        <el-col :span="16">
            <el-input-number size="mini" v-model="model.params.max_time"></el-input-number>        
        </el-col>
      </el-row>
      <el-collapse v-model="collapso_advanced">
        <el-collapse-item title="Advanced options" name="1">
          <el-row :gutter="8">
              <el-col class="paramNameCol" :span="8">
                Safe mode
                <el-tooltip content="Open acceptor with 'donor as referer' when it cannot be opened from donor" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="16">
                  <el-checkbox class="clickCheckbox" v-model="model.params.safe_mode"></el-checkbox>        
              </el-col>
          </el-row>
          <el-row :gutter="8">
              <el-col class="paramNameCol" :span="8">
                Continue on 404
                <el-tooltip content="If the opened acceptor page is 404, try to follow another site link instead of failing" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </el-col>
              <el-col :span="16">
                  <el-checkbox class="clickCheckbox" v-model="model.params.continue_on_http_404"></el-checkbox>        
              </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SetUrlBlocklist',
  props: {
    key: {
      type: Number
    },
    model: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      name: 'Donor Acceptor',
      desc: '',
      donor_uris: this.prepareParam(this, 'donor_uri'),
      uris: this.prepareParam(this, 'uri'),
      referers: this.prepareParam(this, 'referer'),
      modes: ['random', 'table', 'uri_list'],
      collapso_advanced: false,
    }
  },
  methods: {
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading'
    })
  },
  watch: {
    donor_uris(newValue, oldValue) {
        this.model.params.donor_uri = newValue.replace(/\r\n/g,"\n").split("\n");
    },
    uris(newValue, oldValue) {
        this.model.params.uri = newValue.replace(/\r\n/g,"\n").split("\n");
    },
    referers(newValue, oldValue) {
        this.model.params.referer = newValue.replace(/\r\n/g,"\n").split("\n");
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
